import { render } from "./EmployeesOnLeaveConfigModal.vue?vue&type=template&id=40964c42&scoped=true"
import script from "./EmployeesOnLeaveConfigModal.vue?vue&type=script&lang=js"
export * from "./EmployeesOnLeaveConfigModal.vue?vue&type=script&lang=js"

import "./EmployeesOnLeaveConfigModal.vue?vue&type=style&index=0&id=40964c42&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40964c42"]])

export default __exports__